import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from '../../../Auth/AuthContext';
import { BotonVerAtencionesPersona } from '../../Utils/BotonVerAtencionesPersona';

export default function DiagnosticoDeudas(){
    const { token } = useAuth();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const [datosDeudas, setDatosDeudas] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage) => {
        const url = `/caracterizacion/diagnosticos/listardatodeudas?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosDeudas(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    function verAtencionPersona (row){
            return <BotonVerAtencionesPersona verAtencionesPersona={verAtencionesPersona} id={row.idpersona} row={row} />
        }
    const columns = [
            {
                name: 'Acciones',
                cell: row => verAtencionPersona(row),
                ignoreRowClick: true,
                width: '3%'
            },
        { name: 'Identificación Cabeza', selector: row => row.idpersona, sortable: true, width:'11%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '20%'},
        { name: 'Tipo de Pérdida', selector: row => row.bien, sortable: true, width: '15%'},
        { name: 'Descripcón', selector: row => row.descripcion, sortable: true, width: '20%' },
        { name: 'Cantidad', selector: row => row.cantidad, sortable: true, width: '10%' },
        { name: 'Costo', selector: row => row.valor, sortable: true, width: '10%' }
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    const language = {
        zeroRecords: 'Nothing found - sorry'
    }
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatodeudas?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_deudas.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Diagnostico deudas</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/consultas/verdiagnosticos" >Diagnosticos</NavLink></li>
                        <li className="breadcrumb-item active"> Deudas</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos />
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosDeudas} titulo={'Informe Datos Deudas'} exportarCSV={exportarCSV} />
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Deuda"
                                    columns={columns}
                                    data={datosDeudas}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    language={language}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}